import { CanActivate, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable( {
    providedIn: 'root'
} )
export class AlwaysAuthGuardService implements CanActivate {

    constructor( private cookieService: CookieService, private router: Router ) {
    }

    authUser() {
        if ( this.cookieService.get( 'Token' ) && this.cookieService.get( 'Provider' ) ) {
            return true;
        } else {
            this.router.navigate( ['login'] );
        }
    }

    canActivate() {
        return this.authUser();
    }
}
